import * as React from 'react';

import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { trackReportItemClick } from '../tracking';
import { useScrollToBlock } from '../../Scrolling';

export const useItemClickHandler = () => {
  const scrollToBlock = useScrollToBlock();

  return React.useCallback(
    (id: EScrollingBlocks) => {
      trackReportItemClick(id);
      scrollToBlock(id);
    },
    [scrollToBlock],
  );
};
